import { DefaultButton, Dialog, DialogFooter, PrimaryButton } from "@fluentui/react";
import * as React from "react";
import * as ReactDOM from "react-dom";

export const ShowDialog = (title: string, subText: string) => {
    const domElement = document.createElement("div");
    document.body.appendChild(domElement);

    const onDismiss = () => {
        ReactDOM.unmountComponentAtNode(domElement);
        document.body.removeChild(domElement);
    };

    const dialogElement = React.createElement(Dialog, {
        isOpen: true,
        title: title,
        subText: subText,
        onDismiss: onDismiss
    },
        React.createElement(DialogFooter, null,
            React.createElement(PrimaryButton, { onClick: onDismiss, text: "OK" })
        )
    );

    ReactDOM.render(dialogElement, domElement);
};

export interface IConfirmDialogProps { Title: string, Text: string, OkButtonText?: string, CancelButtonText?: string }
export const ConfirmDialog: (props: IConfirmDialogProps) => Promise<boolean> = async (props: IConfirmDialogProps) => {
    const { Text, Title, CancelButtonText, OkButtonText } = props;
    const element = document.createElement("div");
    document.body.appendChild(element);

    return new Promise<boolean>((resolve) => {
        const form = React.createElement(Dialog, {
            dialogContentProps: { title: Title, subText: Text },
            hidden: false,
            modalProps: { isBlocking: true },
            onDismiss: () => {
                resolve(false);
            }
        }, <DialogFooter>
            <PrimaryButton onClick={() => resolve(true)} text={OkButtonText ?? "Ok"} />
            <DefaultButton onClick={() => resolve(false)} text={CancelButtonText ?? "Annuller"} />
        </DialogFooter>);

        ReactDOM.render(form, element);
    }).finally(() => {
        ReactDOM.unmountComponentAtNode(element);
        document.body.removeChild(element);
    });
}
